import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Globe } from 'lucide-react';

export default function PublicPagesSystem() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-white mb-2">Public Pages System</h1>
        <p className="text-[#8A93A6]">Public-facing pages, landing pages, and SEO management</p>
      </div>
      <Card className="glass">
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2 text-white">
            <Globe className="h-5 w-5 text-sky-500" />
            Public Pages
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-[#8A93A6]">Public-facing page management, landing pages, and SEO settings will be configured here.</p>
        </CardContent>
      </Card>
    </div>
  );
}
